import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold mb-6 text-primary">Privacy Policy</h1>
        <p className="mb-4 text-gray-700">
          <strong>Page4Change</strong> is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.
        </p>
        <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>Personal identification information (Name, email address, etc.)</li>
          <li>Usage data and cookies</li>
          <li>Any information you voluntarily provide</li>
        </ul>
        <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Information</h2>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>To provide and maintain our service</li>
          <li>To improve and personalize your experience</li>
          <li>To communicate with you</li>
          <li>To comply with legal obligations</li>
        </ul>
        <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights</h2>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>You have the right to access, update, or delete your personal information</li>
          <li>You may opt out of certain communications at any time</li>
        </ul>
        <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
        <p className="mb-6 text-gray-700">
          If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@page4change.org" className="text-primary underline">info@page4change.org</a>.
        </p>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage; 